import { emptyStyle } from "../constants";
import { IStyle } from "../types";

export enum RemoveTextResult {
	textIsEmpty,
	complete,
	nullTextLength,
	forceRemovePrevious,
	forceRemoveNext,
}

export class TextNode {
	// do not mutate style
	public style: IStyle;
	public text: string;

	constructor(text: string, style?: IStyle) {
		this.text = text;
		this.style = style || emptyStyle;
	}
	isEmpty() {
		return this.text.length === 0;
	}
	insert(data: string, offset: number) {
		this.text = this.text.slice(0, offset) + data + this.text.slice(offset);
	}
	remove(offset: number, prev: boolean): RemoveTextResult {
		if (this.isEmpty()) {
			return RemoveTextResult.textIsEmpty;
		}
		if (offset === 0 && prev) {
			return RemoveTextResult.forceRemovePrevious;
		}
		if (offset === this.text.length && !prev) {
			return RemoveTextResult.forceRemoveNext;
		}

		if (prev) {
			this.text = this.text.slice(0, offset - 1) + this.text.slice(offset);
		} else {
			this.text = this.text.slice(0, offset) + this.text.slice(offset + 1);
		}

		if (this.text.length === 0) {
			return RemoveTextResult.nullTextLength;
		}

		return RemoveTextResult.complete;
	}
}
